import { render, staticRenderFns } from "./RiskLogs.vue?vue&type=template&id=4154d8c4&scoped=true"
import script from "./RiskLogs.vue?vue&type=script&lang=ts"
export * from "./RiskLogs.vue?vue&type=script&lang=ts"
import style0 from "./RiskLogs.vue?vue&type=style&index=0&id=4154d8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154d8c4",
  null
  
)

export default component.exports